import { RefreshCw, X } from "lucide-react"
import { useState } from "react"
import { useSWUpdate } from "@/hooks/use-sw-update"
import { translate } from "@/lib/i18n/translate"
import { Button } from "@/components/ui/button"

export function UpdateBanner() {
  const { updateAvailable, applyUpdate } = useSWUpdate()
  const [dismissed, setDismissed] = useState(false)

  if (!updateAvailable || dismissed) return null

  return (
    <div
      className="fixed bottom-20 md:bottom-4 left-4 right-4 z-[55] mx-auto max-w-lg rounded-lg border border-primary/40 bg-background/95 p-3 shadow-lg backdrop-blur"
      role="alert"
    >
      <div className="flex items-center gap-3">
        <RefreshCw className="h-5 w-5 shrink-0 text-primary" aria-hidden />
        <p className="flex-1 text-sm">{translate("pwa.updateAvailable")}</p>
        <Button size="sm" onClick={() => applyUpdate()}>
          {translate("pwa.updateNow")}
        </Button>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="rounded p-1 text-muted-foreground hover:text-foreground"
          aria-label={translate("common.close")}
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
